export default __webpack_public_path__ + "static/media/winner_small2.7b243afb.png";